// This import loads the firebase namespace along with all its type information.
import GameMetric from './game-metric-model'

export async function load_gameMetrics(): Promise<GameMetric[]> {
  throw 'Not implemented'
}

export async function delete_gameMetric(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameMetric(): Promise<GameMetric> {
  throw 'Not implemented'
}
